import { useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { fetch } from 'Api/myCoursesPage';
import {
  COURSE_STATUS_APPROVED,
  COURSE_STATUS_APPROVED_NAME,
  COURSE_STATUS_PENDING,
  COURSE_STATUS_PENDING_NAME,
  COURSE_STATUS_REJECTED,
  COURSE_STATUS_REJECTED_NAME,
} from 'Constants/General';

export const STATUS_OPTIONS = [
  { id: COURSE_STATUS_APPROVED, name: COURSE_STATUS_APPROVED_NAME },
  { id: COURSE_STATUS_PENDING, name: COURSE_STATUS_PENDING_NAME },
  { id: COURSE_STATUS_REJECTED, name: COURSE_STATUS_REJECTED_NAME },
];

const DEBOUNCE_MS = 500;

const useFetch = setIsLoading => {
  const [courses, setCourses] = useState([]);
  const [category, setCategory] = useState(null);
  const [name, setName] = useState(null);
  const [debouncedName, setDebouncedName] = useState(null);
  const [status, setStatus] = useState(null);
  const [categories, setCategories] = useState([]);
  const [isCard, setIscard] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedName(name === '' ? null : name);
    }, DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [name]);

  useEffect(() => {
    let isMounted = true;
    const newCategory = category === '' ? null : category;

    fetch({ category: newCategory, name: debouncedName }).then(data => {
      if (!isMounted) return;
      setCourses(data?.courses?.filter(course => course[course.length - 2] !== true));
      setCategories(data.categories);
      setIsLoading(false);
    });

    return () => {
      isMounted = false;
    };
  }, [category, debouncedName]);

  const filteredCourses = useMemo(() => {
    if (!status) return courses;
    return courses.filter(course => course[course.length - 1]?.id === status);
  }, [courses, status]);

  const sendToCourseDetails = (course, colorCategory) => {
    history.push({
      pathname: '/cursos/detalles',
      state: {
        update: true,
        course,
        colorCategory,
        isComingFrom: '/mis-cursos',
      },
    });
  };

  return {
    courses: filteredCourses,
    categories,
    setCategory,
    setName,
    setStatus,
    setIscard,
    isCard,
    sendToCourseDetails,
  };
};

export default useFetch;
